import gql from 'graphql-tag';

const CONFIRM_INVOICE_ORDER = gql`
  mutation ConfirmInvoiceOrder($input: ConfirmInvoiceOrderInput!) {
    confirmInvoiceOrder(input: $input) {
      __typename
      ... on InvoiceOrderSuccessPayload {
        responseStatus
      }
      ... on InvoiceOrderNotFoundPayload {
        reason
      }
      ... on OrderExpiredError {
        message
      }
      ... on OrderNotFoundError {
        message
      }
      ... on OrderInvalidError {
        message
      }
      ... on PromotionInvalidError {
        message
      }
    }
  }
`;

export default CONFIRM_INVOICE_ORDER;
